<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nZg1ke/CoverDesign.jpg?1684514922878" alt="This image is the cover for the book Rainbows in Sea Glass, 2019 Advent Calendar | Homemade for the Holidays"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rainbows in Sea Glass, 2019 Advent Calendar | Homemade for the Holidays
      </h1>
      <p class="bookDescription body article font2">
        <p>Kyle has loved James, his best friend’s older brother, for as long as he can remember. Unfortunately James is a player, and Kyle has no desire to be his latest conquest. When James suddenly turns the full weight of his charm on him, Kyle flees to Cape May Point to collect sea glass and Cape May diamonds to make a St. Nicholas Day present for his aunt. </p> <p>James has always taken Kyle’s presence for granted and he’s shocked to find how integral Kyle is to his life and future happiness. Braving his family’s well-meaning attempts to help and a sudden winter storm, James heads to the shore to convince Kyle that the most precious thing they’ll find on the beach is each other.</p><p><i>A story from the Dreamspinner Press 2019 Advent Calendar "Homemade for the Holidays."</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Katil
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f2defec2